import { useState } from "react";
import { Lightbulb, X } from "lucide-react";

const KEY = "pb_hide_margin_note";

// Informativo simples: quem define a margem é o cliente. Pode ser ocultado (fica salvo no navegador).
export const MarginNote = () => {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden) return null;
  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-500/25 bg-amber-500/5 px-4 py-3 text-sm" data-testid="pricing-margin-note">
      <Lightbulb className="w-4 h-4 shrink-0 mt-0.5 text-amber-400" />
      <p className="text-muted-foreground leading-relaxed"><span className="font-semibold text-foreground">Margem desejada — quem define é você.</span> Não existe uma margem única para todos os produtos. Compare a margem líquida real de cada canal abaixo com o que faz sentido para o seu negócio e ajuste o preço livremente.</p>
      <button type="button" onClick={() => { localStorage.setItem(KEY, "1"); setHidden(true); }} title="Ocultar este aviso" className="shrink-0 rounded-md p-1 text-muted-foreground hover:text-foreground hover:bg-secondary" data-testid="pricing-margin-note-close"><X className="w-4 h-4" /></button>
    </div>
  );
};
